import { render, staticRenderFns } from "./responsibilities.vue?vue&type=template&id=b6d48810&scoped=true&"
import script from "./responsibilities.vue?vue&type=script&lang=js&"
export * from "./responsibilities.vue?vue&type=script&lang=js&"
import style0 from "./responsibilities.vue?vue&type=style&index=0&id=b6d48810&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d48810",
  null
  
)

export default component.exports